import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import UserGroupForm from "@/components/forms/user-groups/UserGroupForm";
import { z } from "zod";
import { userGroupValidators } from "@shared/validators/admin/user-groups-validators";

type UserGroup = z.infer<typeof userGroupValidators.userGroupSchema>;

interface UserGroupDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    userGroup?: UserGroup | null;
    mode?: "create" | "edit";
}

const UserGroupDialog = ({ open, onOpenChange, userGroup, mode = "create" }: UserGroupDialogProps) => {
    const isEditing = mode === "edit" && userGroup;
    const isIdpGroup = userGroup?.externalId != null;

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-md md:max-w-2xl">
                <DialogHeader>
                    <DialogTitle>
                        {isEditing 
                            ? isIdpGroup 
                                ? "View IDP Group" 
                                : "Edit User Group"
                            : "Create New User Group"}
                    </DialogTitle>
                    <DialogDescription>
                        {isEditing
                            ? isIdpGroup
                                ? "This group is managed by your Identity Provider and syncs automatically."
                                : "Update user group information."
                            : "Create a new user group to organize users and control access to agent connections."}
                    </DialogDescription>
                </DialogHeader>
                <UserGroupForm userGroup={userGroup} mode={mode} onSuccess={() => onOpenChange(false)} />
            </DialogContent>
        </Dialog>
    );
};

export default UserGroupDialog;
